const consultaPublicaSentencias = {
    ConsultaExpediente: 'SICSEN/Consulta/ConsultaExpediente',    
    ObtenerFiltroParaPerspectivaDeGenero: 'SICSEN/Consulta/ObtenerFiltroParaPerspectivaDeGenero',
    ConvierteBase64: 'SICSEN/Consulta/ConvierteBase64',
    DescargaWord: 'SICSEN/Consulta/DescargaWord'
}

const consulta = {
    consultaPublicaSentencias: consultaPublicaSentencias, 
}

export default consulta;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICSEN/sistema/consulta/consulta.js
// module id = null
// module chunks = 